import React from "react";
import { useLocation, useNavigate } from "react-router";
import { AdminFormPage } from "@components/CatalogIndex/AdminFormPage";
import NoteForm from "../NoteForm/NoteForm";
import { Note } from "../types/Note";

const FORM_ID = "note-form";

interface Props {
  projectId: string;
  permission: string;
  projectStatus: string;
}

const Edit: React.FC<Props> = ({ projectId, permission, projectStatus }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const note: Note = location.state?.note;

  const canSave = permission !== "view" && projectStatus === "building";

  return (
    <AdminFormPage
      title="Edit Note"
      formId={canSave ? FORM_ID : undefined}
      onCancel={() => navigate(`/projects/${projectId}/notes`, { state: null })}
    >
      <NoteForm formId={FORM_ID} projectId={projectId} note={note} />
    </AdminFormPage>
  );
};

export default Edit;
